import ContactUsSection from "@components/ContactUsSection/ContactUsSection";
import { Email, Whatsapp } from "@components/icons/icons";
import Newsletter from "@components/Newsletter/Newsletter";
import Sectioncomminity from "@frontpage/section_comminity";
import BaseLayout from "@layout/base-layout";
import { Button, Collapse, Form, Input } from "antd";
import FormBuilder from "antd-form-builder";
import _, { lowerCase } from "lodash";
import { inject, observer } from "mobx-react";
import { i18n } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  contactDeData,
  contactEnData,
} from "../../components/helper/contactData";

const { Search } = Input;

const FaqIndex = inject("CoreStore")(
  observer((props) => {
    const { t } = useTranslation("common");
    const [isSearch, setIsSreach] = useState(false);
    const [form] = Form.useForm();
    const forceUpdate = FormBuilder.useForceUpdate();
    const [results, setResults] = useState([]);

    const searchFaq = (value) => {
      let temp = props.CoreStore.lang === "de" ? contactDeData : contactEnData;
      const uniqueIds = [];
      if (value == "") {
        setIsSreach(false);
      } else {
        let toSearch = value;
        for (let i = 0; i < temp.length; i++) {
          temp[i].desc.map((item, index) => {
            for (let key in item) {
              if (lowerCase(item[key]).indexOf(lowerCase(toSearch)) != -1) {
                uniqueIds.push(temp[i].desc[index]);
              }
            }
          });
        }

        setResults(_.uniqWith(uniqueIds, _.isEqual));
        setIsSreach(true);
      }
    };

    const _renderResult = () => {
      return (
        <Collapse
          accordion
          bordered={false}
          expandIconPosition="end"
          className={"aclist-normal"}
        >
          {results.map((d, i) => (
            <Collapse.Panel
              header={
                <div className={"flex flex-row space-x-3 text-[#12a3ba]"}>
                  <div className={"flex font-medium "}>{d.title}</div>
                </div>
              }
              key={"c" + i}
              className={"collapse-mov2"}
            >
              <div className={"p-4"}>{d.desc}</div>
            </Collapse.Panel>
          ))}
        </Collapse>
      );
    };

    const scrollFunc = (id) => {
      window.scrollTo(0, 0);
    };

    const _renderTab = () => {
      let temp = props.CoreStore.lang === "de" ? contactDeData : contactEnData;
      return (
        <Collapse
          accordion
          bordered={false}
          className={"aclist-normal"}
          expandIconPosition="end"
          onChange={scrollFunc}
        >
          {temp.map((d, i) => (
            <Collapse.Panel
              header={
                <div className={"flex flex-row space-x-3"}>
                  <div className={"flex font-medium text-[16px]"}>
                    {d.title}
                  </div>
                </div>
              }
              id={i}
              key={"c" + i}
              className={"collapse-mov2"}
            >
              <Collapse>
                {d.desc.map((item, index) => {
                  return (
                    <Collapse.Panel
                      header={
                        <p
                          className={
                            "flex flex-row space-x-3 text-[#12a3ba] text-[16px]"
                          }
                        >
                          {item.title}{" "}
                        </p>
                      }
                    >
                      <div
                        className="px-4 text-[16px] pb-4"
                        dangerouslySetInnerHTML={{ __html: item.desc }}
                      ></div>
                    </Collapse.Panel>
                  );
                })}
              </Collapse>
            </Collapse.Panel>
          ))}
        </Collapse>
      );
    };

    const _formBuilder = () => {
      const meta = {
        columns: 4,
        formItemLayout: null,
        colon: true,
        fields: [
          {
            key: "name",
            placeholder: t("contact.your_name"),
            colSpan: 2,
            rules: [
              {
                required: true,
                message: t("validation.required_message", {
                  name: t("contact.your_name"),
                }),
              },
            ],
          },
          {
            key: "email",
            placeholder: t("contact.email"),
            colSpan: 2,
            rules: [
              { type: "email", message: t("validation.invalid_email_format") },
              {
                required: true,
                message: t("validation.required_message", {
                  name: t("contact.email"),
                }),
              },
            ],
          },
          {
            key: "phone",
            placeholder: t("contact.phone"),
            colSpan: 2,
            rules: [
              {
                required: true,
                message: t("validation.required_message", {
                  name: t("contact.phone"),
                }),
              },
            ],
          },
          {
            key: "subject",
            placeholder: t("contact.subject"),
            rules: [
              {
                required: true,
                message: t("validation.required_message", {
                  name: t("contact.subject"),
                }),
              },
            ],
            colSpan: 2,
          },
          {
            key: "message",
            placeholder: t("contact.message_placeholder"),
            rules: [
              {
                required: true,
                message: t("validation.required_message", {
                  name: t("contact.message"),
                }),
              },
            ],
            colSpan: 4,
            widget: "textarea",
          },
        ],
      };
      return (
        <Form
          className={"w-100 flex flex-col md:px-14 form-base form-base-gray"}
          layout={"inline"}
          ref={form}
          onValuesChange={() => forceUpdate()}
        >
          <FormBuilder meta={meta} form={form} />

          <div>
            <Button htmlType={"submit"} className={"btn-orange px-8"}>
              {t("contact.btn_send")}
            </Button>
          </div>
        </Form>
      );
    };

    const canonicalUrl = `${process.env.NEXT_PUBLIC_SITE_ADDRESS}contact`;

    return (
      <div>
        <NextSeo
          title={t("tag.contact_meta_title")}
          description={t("tag.contact_meta_description")}
          canonical={canonicalUrl}
          openGraph={{
            url: canonicalUrl,
            title: `${t("tag.contact_meta_title")}`,
            description: `${t("tag.contact_meta_description")}`,
            site_name: "Moverii",
          }}
          twitter={{
            handle: "@handle",
            site: "@site",
            cardType: "summary_large_image",
          }}
        />
        {/** section 6 **/}
        <section className={"container mx-auto pt-20 pb-[100px]"}>
          <div
            className={
              "flex px-5 md:px-0 flex-col items-center space-y-5 max-w-3xl mx-auto"
            }
          >
            <div className={"flex"}>
              <h1 className={"font-bold  text-center text-[28px]"}>
                {t("contact.Hi! How can we help you?")}
              </h1>
            </div>
            <div className={"flex flex-col text-center text-[16px]"}>
              <p>
                {t(
                  "contact.With moverii we make your active dream vacation come true. From the planning and booking to the journey itself - we are always at your side! Simply select a topic or enter your question in the following search field and you will receive comprehensive answers from various topics related to your sports & active travel. if you don’t find an answer to your question or have a special request, you can always contact us, and you will receive an answer within a few hours."
                )}
              </p>
              <p>{t("contact.With_moverii_2")}</p>
            </div>
          </div>

          <div
            className={"flex flex-col justify-center items-center mx-auto py-6"}
          >
            <div className={"flex flex-row justify-center mt-6 md:w-5/12"}>
              <Search
                placeholder={t("contact.search_place_holder")}
                className={"search-blog search-contact w-full"}
                enterButton={t("contact.Search")}
                size="medium"
                bordered={false}
                onSearch={(value) => searchFaq(value)}
                onChange={(e) => searchFaq(e.target.value)}
              />
            </div>
          </div>
          <div
            className={"flex flex-col justify-center mx-auto py-6  max-w-3xl"}
          >
            {isSearch ? <>{_renderResult()}</> : <>{_renderTab()}</>}
          </div>

          <div className={"mt-4"}>
            <ContactUsSection
              title={t("common:landing.euro_contact_us_title")}
              descritpion={t("common:landing.euro_contact_us_subtitle")}
              customClass="!px-6 md:!px-0"
              formInputs={[
                {
                  type: "text",
                  placeholder: t(
                    "common:landing.euro_contact_us_input_first_name"
                  ),
                },
                {
                  type: "text",
                  placeholder: t("common:landing.euro_contact_us_input_email"),
                },
                {
                  type: "text",
                  placeholder: t("common:landing.euro_contact_us_input_phone"),
                },
                {
                  type: "text",
                  placeholder: t(
                    "common:landing.euro_contact_us_input_subject"
                  ),
                },
              ]}
              formTextarea={t(
                "common:landing.euro_contact_us_input_write_message"
              )}
              formButton={t(
                "common:landing.euro_contact_us_input_send_message"
              )}
              cardImageSrc={
                process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
                "cdn/statics/contact_help/moverii-team.jpg"
              }
              cardDesc={t("common:landing.portugal_contact_us_card_subtitle")}
              cardItems={[
                {
                  title: t("common:landing.euro_contact_us_card_email"),
                  address: "team@moverii.de",
                  icon: <Email />,
                },
                {
                  title: t("common:landing.euro_contact_us_card_whatsapp"),
                  address: "+49 (0)163 3122 260",
                  icon: <Whatsapp />,
                },
              ]}
            />
          </div>
        </section>
        <section className={"container mx-auto mb-10 px-6 md:px-0"}>
          <Link href={"/tripfinder"}>
            <a href={"/tripfinder"} className={""}>
              {" "}
              <div className={"flex"}>
                <div
                  className={
                    "flex flex-col space-y-4 rounded-2xl text-center items-center relative  px-16 py-5 w-full  bg-center bg-no-repeat bg-cover min-h-[400px] md:min-h-[300px] justify-center"
                  }
                  style={{
                    backgroundImage:
                      "url(https://api.moverii.de/cdn/statics/contact_help/moverii-Aktivurlaub-TripFinder.jpg)",
                  }}
                >
                  <div
                    className={
                      "absolute left-0 right-0 top-0 bottom-0 z-0 rounded-2xl bg-black opacity-20"
                    }
                  />
                  <h5 className={"text-white text-[28px] font-black z-10 azo"}>
                    {t("contact.Find your dream vacation in just a breeze!")}
                  </h5>
                  <p className={"text-white md:w-3/5 text-[16px] z-10 azo"}>
                    {t("contact.desc-banner")}
                  </p>
                  <div className={"flex flex-row pt-3 z-10"}>
                    <div
                      className={
                        "px-[60px] py-[10px] rounded-2xl bg-[#12a3ba] hover:bg-[#12a3ba] hover:text-white text-white font-bold text-[16px] flex flex-row space-x-2 items-center"
                      }
                    >
                      <p>{t("contact.Get started")}</p>
                      <div>
                        <img
                          src={"/static/icons/arrowrightwhite.svg"}
                          alt="arrow"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </Link>
        </section>
        <Newsletter
          image1={"/static/images/news.png"}
          image2={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Aktivurlaub_moverii.jpg"
          }
          image3={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Yoga-Retreats_moverii.jpg"
          }
          title={t("contact.newsletter_title")}
          description={t("contact.newsletter_description")}
          inputPlaceholder={t("contact.newsletter_placeholder")}
          buttonTitle={t("contact.newsletter_button")}
        />
        <section className={"container mx-auto mb-10"}>
          <Sectioncomminity className={""} mode={"white"} />
        </section>
      </div>
    );
  })
);

FaqIndex.Layout = BaseLayout;

export const getServerSideProps = async ({ locale }) => {
  if (process.env.NODE_ENV === "development") {
    await i18n?.reloadResources();
  }
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default FaqIndex;
